<template>
<div class="info">
	<div class="title">{{title}}</div>
	<Form :label-width="150" class="mt15">
		<FormItem label="公司名称：" class="w600" v-if="info.identityType=='COMPANY'">
			{{info.subjectName}}
		</FormItem>
		<FormItem label="统一社会信用代码：" class="w600" v-if="info.identityType=='COMPANY'">
			{{info.idNumber}}
		</FormItem>
		<FormItem label="申请人姓名：" class="w600" v-if="info.identityType=='PERSON'">
			{{info.subjectName}}
		</FormItem>
		<FormItem label="申请人身份证号码：" class="w600" v-if="info.identityType=='PERSON'">
			{{info.idNumber}}
		</FormItem>
		<FormItem label="通讯地址：" class="w600">
			{{info.fullAddress}}
		</FormItem>
		<FormItem label="联系人：" class="w600">
			{{info.contactName}}
		</FormItem>
		<FormItem label="联系电话：" class="w600">
			{{info.contactPhone}}
		</FormItem>
		<FormItem label="联系人邮箱：" class="w600">
			{{info.contactEmail}}
		</FormItem>
		<FormItem label="资料上传：">
			<div class="upload-item" v-for="(item, index) in fileList" :key="index">
				<div v-if="item.type=='image'">
					<ImageShow :url="item.url" />
					{{item.name}}
				</div>
				<div v-else>
					<Icon type="ios-paper-outline" size="50" />
					<br>
					<a :href="item.url" target="_blank">点击下载</a><br>
					{{item.name}}
				</div>
			</div>
		</FormItem>
	</Form>
</div>
</template>
<script>
import ImageShow from './Image'
export default {
	components:{ ImageShow },
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		title:{
			type:String,
			default:'申请人信息'
		},
		uploadFileList:{
			type:Array,
			default(){
				return []
			}
		}
	},
	computed: {
		fileList(){
			if(this.info.annexUrls){
				let list=[]
				let baseIndex=0;
				let annexUrls=this.info.annexUrls.split(',')
				if(this.info.identityType=='COMPANY'){
					list.push({
						name:'营业执照',
						type:'image',
						url:annexUrls[0]
					})
					baseIndex=1;
				}else if(this.info.identityType=='PERSON'){
					list=[
						{name:'身份证正面',type:'image',url:annexUrls[0]},
						{name:'身份证反面',type:'image',url:annexUrls[1]},
					]
					baseIndex=2;
				}
				this.uploadFileList.forEach((item,index)=>{
					list.push({
						...item,
						url:annexUrls[baseIndex+index]
					})
				})
				console.log(list)
				return list
			}
			return []
			
		}
	},
}
</script>
<style scoped lang="less">
.upload-item{
	min-width: 90px;
	display: inline-block;
	text-align: center;
	margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/ApplicantInfo.vue